import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tripmap',
  templateUrl: './tripmap.component.html',
  styleUrls: ['./tripmap.component.scss']
})
export class TripmapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
